export const primary = '#00004d';
export const secondary = '#0000cc';
export const loadingColor = '#0000cc';
export const success = '#2ecc71';
export const error = '#e74c3c';
export const warn = '#F1C40F';
export const white = '#FFFFFF';
export const black = '#000000';
export const darkGray = '#121212';
export const middleGray = '#868686';
export const middleGraySecondary = '#5c5a5a';
export const lightGray = '#d1d2d4';
export const lighterGray = '#fafafa';
export const primaryGradient = `linear-gradient(90deg, #0000cc 0%, #0000cc 100%)`;

// Seven brand palette
export const sevenGreenPrimary = '#1BBB3F';
export const sevenGreenVibrant = '#22DB3D';
export const sevenGreenDark = '#0B7328';
export const sevenYellow = '#FFC61A';
export const sevenYellowWarm = '#F5A606';
export const sevenCyan = '#14B8D1';
export const sevenCyanLight = '#DCF1F5';
export const sevenNavy = '#172136';
export const sevenSurfaceGreen = '#F4F9F5';
export const sevenSurfaceYellow = '#FAF7F0';
export const sevenTextPrimary = '#082033';
export const sevenTextSoft = '#67707F';
export const sevenBorder = '#E1E4EA';
export const sevenDestructive = '#EF4444';
